module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "pull-view"
  }, [_c('Scroller', {
    attrs: {
      "options": _vm.pullOptions
    }
  }, _vm._l((_vm.baseNum), function(i) {
    return _c('ListItem', {
      attrs: {
        "title": 'Item-' + (_vm.baseNum - i)
      }
    })
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-be830f4a!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/scrollerView.vue
// module id = 283
// module chunks = 0